import { Tooltip } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Grid } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import SimpleDialogDemo from "../../Pages/Approvals/ImageDailogBox";
import ViewIcon from "../../Pages/Invitations/ViewIcon";
import { getAllVisitorDocuments } from "../../slices/VisitorDocuments/VisitorDocumentSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import "./profileCard.css";

const BootstrapDialog = styled(Dialog)(({ theme, darkMode }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    overflowY: "clip",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    overflowY: "visible",
    borderRadius: "20px",
    minWidth: "120vh",
    height: "75%",
    opacity: 1,
    backgroundColor: darkMode ? "#0E2A41" : "#FFFFFF",
  },
  "& .MuiDialogContent-root ": {
    padding: "16px 24px",
    position: "relative",
    bottom: "80px",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 0, marginBottom: 1 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function BlockedVisitorProfile(props) {
  const rowDataMode = props.rowData.visitMode;
  const dispatch = useDispatch();
  const [imageArray, setImageArray] = useState([]);
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const handleClickOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
    handleClickOpenVisitorDocuments();
  };

  const handleClickOpenVisitorDocuments = () => {
    if (!CommonUtil.isEmptyString(props.rowData)) {
      loadVisitorDocumentObjectKeys(props.rowData);
    }
    setOpen(true);
  };

  const loadVisitorDocumentObjectKeys = () => {
    dispatch(getAllVisitorDocuments(props))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && data.data.length > 0) {
          const imageUrls = data.data
            .filter((imageData) => "url" in imageData)
            .map((imageData) => imageData.url);
          setImageArray(imageUrls);
        }
      });
  };
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      setDiaLogBoxBlur(false);
    }
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 45) {
      return text.substring(0, 45) + "...";
    } else {
      return text;
    }
  };

  return (
    <div>
      <div onClick={handleClickOpen}>
        <ViewIcon darkMode={darkMode} />
      </div>
      <Grid>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          disableBackdropClick
          disableEscapeKeyDown
          BackdropProps={{
            style: {
              backdropFilter: "blur(5px)",
            },
          }}
        >
          <BootstrapDialogTitle onClose={handleClose}>
            <Avatar
              alt={props.rowData.visitor.firstName}
              src={
                props.rowData.visitor.profilePhotoURL !== undefined
                  ? props.rowData.visitor.profilePhotoURL
                  : null
              }
              sx={{
                width: 150,
                height: 150,
                bottom: "80px",
                margin: "auto",
                border: "solid #FFFF",
                borderWidth: "7px",
              }}
            />
            <Tooltip title={props.rowData.visitor.lastName === null
              ? props.rowData.visitor.firstName
              : props.rowData.visitor.firstName +
              " " +
              props.rowData.visitor.lastName}>
              <div
                className="CssTextProfileViewPageName"
                style={{ color: darkMode ? "#fff" : "" }}
              >
                {props.rowData.visitor.lastName === null
                  ? props.rowData.visitor.firstName
                  : props.rowData.visitor.firstName +
                  " " +
                  props.rowData.visitor.lastName}
              </div>
            </Tooltip>
            <div
              className="CssTextProfileViewPagePhone"
              style={{ color: darkMode ? "#fff" : "" }}
            >
              {props.rowData.visitor.phone}
            </div>
          </BootstrapDialogTitle>
          <DialogContent
            style={{
              marginLeft: "70px",
              height: "400px",
              overflow: "auto",
              overflowX: "hidden",
            }}
          >
            <Grid
              container
              spacing={12.25}
              className="CssTextProfileViewPageContent"
              marginTop={0.5}
              style={{ color: darkMode ? "#fff" : "" }}
            >
              <Grid
                container
                spacing={2}
                p={1.25}
                sx={{ color: darkMode ? "#fff" : "", alignItems: "center" }}
              >
                <Grid item xs={12} sm={3}>
                  {t("COMMON042")}
                </Grid>
                <Grid item>
                  :
                </Grid>
                <Tooltip title={props.rowData.visitor.email}>
                  <Grid
                    item
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {handleTextOverflow(props.rowData.visitor.email)}
                  </Grid>
                </Tooltip>
              </Grid>

              <Grid
                container
                spacing={2}
                p={1.25}
                sx={{ color: darkMode ? "#fff" : "", alignItems: "center" }}
              >
                <Grid item xs={12} sm={3}>
                  {t("commonsTextFeildHostValue")}
                </Grid>
                <Grid item>
                  :
                </Grid>
                <Grid
                  item
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {props.rowData.hostName}
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                p={1.25}
                sx={{ color: darkMode ? "#fff" : "", alignItems: "center" }}
              >
                <Grid item xs={12} sm={3}>
                  {t("PURPOSETYPE")}
                </Grid>
                <Grid item>
                  :
                </Grid>
                <Grid
                  item
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {props.rowData.purposeType?.name}
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                p={1.25}
                sx={{ color: darkMode ? "#fff" : "", alignItems: "center" }}
              >
                <Grid item xs={12} sm={3}>
                  {t("COMMON068")}
                </Grid>
                <Grid item>
                  :
                </Grid>
                <Grid
                  item
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {props.rowData.visitorType?.name}
                </Grid>
              </Grid>

              <Grid container spacing={2} p={1.25} sx={{ color: darkMode ? "#fff" : "", alignItems: "center" }}>
                <Grid item xs={12} sm={3}>
                  {t("COMMON001")}
                </Grid>
                <Grid item>
                  :
                </Grid>
                <Grid
                  item
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      color: "#D53033",
                      backgroundColor: "#D5303326",
                      opacity: 1,
                    }}
                  >
                    {props.rowData.status === "BLOCKED" ? "Blocklisted" : ""}
                  </span>
                </Grid>
              </Grid>

              {rowDataMode === "WALKIN_REGISTARTION" ||
                rowDataMode === "SELF_REGISTARTION" ||
                rowDataMode === "WALKIN_REGISTARTION_KIOSK" ? (
                <Grid container spacing={2} p={1.25} sx={{ color: darkMode ? "#fff" : "", alignItems: "center" }}>
                  <Grid item xs={12} sm={3}>
                    Captured Images
                  </Grid>
                  <Grid item>
                    :
                  </Grid>
                  <Grid item xs={6} container direction="row" spacing={1}>
                    {imageArray.map((imageUrl, index) => (
                      <Grid item key={index}>
                        <SimpleDialogDemo
                          button={
                            <Avatar
                              style={{
                                cursor: "pointer",
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                marginRight: "5px", // Adjust margin to control spacing
                              }}
                              alt={`Image ${index + 1}`}
                              src={imageUrl}
                              onClick={handleClickOpenVisitorDocuments}
                            />
                          }
                          child={
                            <Avatar
                              style={{
                                width: "300px",
                                height: "300px",
                                cursor: "pointer",
                              }}
                              alt={`Image ${index + 1}`}
                              src={imageUrl}
                              onClick={handleClickOpenVisitorDocuments}
                            />
                          }
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
            </Grid>
          </DialogContent>
        </BootstrapDialog>
      </Grid>
    </div>
  );
}

export default BlockedVisitorProfile;
